<template>
    <div class="availability-item">
        <div class="list-group-item availability-item__header"
            :class="{ 'disabled':!hasCollapse }"
            :role="hasCollapse ? 'button' : 'listitem'"
            tabindex="-1"
            v-b-toggle="collapseId"
        >
            <div class="row mx-n2">
                <div class="col-auto px-2 d-none d-md-block" style="width: 100px">
                    <div class="responsive-ratio responsive-ratio-1/1">
                        <template v-if="visual">
                            <img class="responsive-ratio-item" :src="visual.thumbnail" :alt="imageAlt(visual)" style="object-fit: cover">
                        </template>
                        <template v-else>
                            <div class="responsive-ratio-item bg-lightsalmon" style="opacity: .5"></div>
                        </template>
                    </div>
                </div>
                <div class="col px-2" style="min-width: 0">
                    <div class="row">
                        <div class="col-sm">
                            <h3 class="availability-item__title font-weight-bold mb-3">
                                <a :href="venueRoomUrl" @click.stop>{{ venueName }}</a>
                            </h3>
                            <div  style="font-size: .875rem">
                                <div class="row mx-n1">
                                    <div class="col-auto px-1">
                                        <svg class="fill-current text-muted" width="1.25em" height="1.25em" style="vertical-align: -.125em">
                                            <use xlink:href="#sprite-calendar"></use>
                                        </svg>
                                    </div>
                                    <div class="col px-1">
                                        <span class="text-nowrap">
                                            du <span>{{ startsAt }}</span>
                                        </span>
                                        <span class="text-nowrap">
                                            au <span>{{ endsAt }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-5">
                            <div class="font-weight-bold" style="font-size: .875rem">{{ roomName }}</div>
                            <div style="font-size: .875rem">
                                {{ roomCity }} ({{ roomDepartment }})
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-auto align-self-center px-2" :class="{ 'invisible': !hasCollapse }">
                    <button class="btn availability-item__expand-button" @click.stop @keydown.stop v-b-toggle="collapseId">
                        <svg class="sprite-inline">
                            <use href="#sprite-plus" xlink:href="#sprite-plus"></use>
                        </svg>
                        <span class="minus" style="width: 1em" v-cloak>
                            —
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <template v-if="hasCollapse">
            <b-collapse :id="collapseId">
                <div class="pb-4">
                    <div class="list-group-item border-0 bg-lightsalmon px-md-4 pb-md-3">
                        <template v-if="roomDescription">
                            <div class="mb-3" v-html="roomDescription"></div>
                        </template>
                        <template v-if="availability.description">
                            <div v-html="availability.description"></div>
                        </template>
                        <div class="mt-3">
                            <a :href="venueRoomUrl">Plus d'informations sur la salle {{ roomName }}...</a>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            availability: Object,
        },

        computed: {
            startsAt() {
                return this.availability.starts_at_formatted
                    .replace((new Date()).getFullYear(), '');
            },
            endsAt() {
                return this.availability.ends_at_formatted
                    .replace((new Date()).getFullYear(), '');
            },
            venueName() {
                return this.availability.venueRoom.venue.title;
            },
            roomName() {
                return this.availability.venueRoom.name;
            },
            roomDepartment() {
                return this.availability.venueRoom.postal_code.substring(0, 2);
            },
            roomCity() {
                return this.availability.venueRoom.city;
            },
            roomDescription() {
                return this.availability.venueRoom.rehearsal_description;
            },
            visual() {
                return this.availability.venueRoom.visual;
            },
            venueRoomUrl() {
                return `${this.availability.venueRoom.venue.url}#room-${this.availability.venueRoom.id}`;
            },
            collapseId() {
                return `availability-${this.availability.id}`;
            },
            hasCollapse() {
                return !!(this.availability.description || this.roomDescription);
            },
        },

        methods: {
            imageAlt(visual) {
                return visual.legend || this.availability.venueRoom.name;
            },
        }
    }
</script>
